/**
 * ChampionMeshRegistry — OCP: champKey → (team) => THREE.Group mesh.
 * New champs register builders; ChampionMeshFactory never switches on id.
 */

function normalizeKey(championKey) {
  if (typeof championKey === 'string') return championKey.toLowerCase();
  const raw = championKey?.championKey || championKey?.name || 'ashe';
  return String(raw).toLowerCase();
}

const builders = new Map();

export const ChampionMeshRegistry = {
  /**
   * @param {string} champKey
   * @param {(team: string) => object} buildFn
   */
  register(champKey, buildFn) {
    builders.set(String(champKey).toLowerCase(), buildFn);
  },

  /**
   * @param {string|object} championKey
   * @param {string} [team='blue']
   * @returns {object|null}
   */
  create(championKey = 'ashe', team = 'blue') {
    const key = normalizeKey(championKey);
    const fn = builders.get(key);
    if (!fn) return null;
    return fn(team);
  },

  has(champKey) {
    return builders.has(normalizeKey(champKey));
  }
};

/** Test-only */
export function _resetChampionMeshRegistryForTests() {
  builders.clear();
}
